// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/sources/SourcesStackItem.scss
// module id = 1327
// module chunks = 0